import React, { useEffect, useState } from 'react'
import Profileheader from './ProfileHeader'
import './profile.css'
import { Col, Container, Row } from 'react-bootstrap'
import { Box, Snackbar } from '@material-ui/core'
import PersonIcon from '@material-ui/icons/Person';
import { SvgIcon } from '@material-ui/core';
import MailIcon from '@material-ui/icons/Mail';
import profileimg from '../../../assets/images/profile/profileimg.jpg';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';
import CallIcon from '@material-ui/icons/Call';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import { useDispatch, useSelector } from 'react-redux'
import { PROFILE_IMAGE } from '../../../utility/apiConstants'
import { profileSuccess } from '../../../store/user/actions/profileAction'
import { getUserAccountDetails } from '../../../store/user/actions/userAcountActions'
import profileImg from "../../../assets/images/images/myprofile.png";

const Myprofile = ()=> {
    const dispatch = useDispatch()

    const { userDetails } = useSelector(state => state.user)
    // console.log('userDetails', userDetails);
    const { successData } = useSelector(state => state.profile)
    const profileAlertClose = () => {
        dispatch(profileSuccess(null))
    }

    useEffect(()=>{
        // dispatch(getUserAccountDetails())
    },[])

    return (
        <div>
            <Profileheader link="/edit-profile" title="Edit Profile" />
            {successData ? (
                <Snackbar
                    anchorOrigin={{ vertical: 'top', horizontal: 'center', }}
                    open={true}
                    autoHideDuration={4000}
                    onClose={profileAlertClose}
                    message={successData}
                    key={{ vertical: 'top', horizontal: 'center' }}
                />
            ):(<span></span>)}

            {userDetails ? (<Container>
                <Row className="itemRow">
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Box className="imguserprofile">
                            <div className="img-ico"><img src={userDetails && userDetails.image ? PROFILE_IMAGE + userDetails?.image : profileImg}></img></div>
                            <div className="tltnameico">Hi, {userDetails.agency_name + ' (' + userDetails.first_name + ' ' + userDetails.last_name+')'}</div>
                        </Box>
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Box className="setBox">
                            <div className="userbox">
                                <div className="user-ico"><SvgIcon><PersonIcon /></SvgIcon></div>
                                <div className="user-details">
                                    <div className="tlthedae">Agency Name</div>
                                    <div className="tltclearboldname">{userDetails.first_name + ' ' + userDetails.last_name}</div>
                                </div>
                            </div>
                        </Box>
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Box className="setBox">
                            <div className="userbox">
                                <div className="user-ico"><SvgIcon><MailIcon /></SvgIcon></div>
                                <div className="user-details">
                                    <div className="tlthedae">Email ID</div>
                                    <div className="tltclearboldname">{userDetails.email}</div>
                                </div>
                            </div>
                        </Box>
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Box className="setBox">
                            <div className="userbox">
                                <div className="user-ico"><SvgIcon><CreditCardIcon /></SvgIcon></div>
                                <div className="user-details">
                                    <div className="tlthedae">PAN Number</div>
                                    <div className="tltclearboldname">{userDetails.pan_number}</div>
                                </div>
                            </div>
                        </Box>
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Box className="setBox">
                            <div className="userbox">
                                <div className="user-ico"><SvgIcon><PhoneAndroidIcon /></SvgIcon></div>
                                <div className="user-details">
                                    <div className="tlthedae">Mobile Number</div>
                                    <div className="tltclearboldname">{userDetails.country_code_value} {userDetails.phone}</div>
                                </div>
                            </div>
                        </Box>
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Box className="setBox">
                            <div className="userbox">
                                <div className="user-ico"><SvgIcon><CallIcon /></SvgIcon></div>
                                <div className="user-details">
                                    <div className="tlthedae">Office Phone Number</div>
                                    <div className="tltclearboldname">{userDetails.country_code_value} {userDetails.office_area_code} {userDetails.office_phone}</div>
                                </div>
                            </div>
                        </Box>
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Box className="setBox">
                            <div className="userbox">
                                <div className="user-ico"><SvgIcon><LocationOnIcon /></SvgIcon></div>
                                <div className="user-details">
                                    <div className="tlthedae">Address</div>
                                    <div className="tltclearboldname">{userDetails.address}</div>
                                </div>
                            </div>
                        </Box>
                    </Col>
                </Row>
            </Container>) : <span>Loading...</span>  }
            
        </div>
    )
}

export default Myprofile
